<template>
  <div class="d-block full-width">
    <div v-for="(value, date) in itemLog" :key="date" class="pt-4">
      <div class="subtitle-1 py-2">{{ date | date }}</div>
      <v-card outlined tile>
        <template v-for="(log, index) in value">
          <v-divider v-if="index != 0" :key="index + 'divider'"></v-divider>
          <v-row :key="index" class="pa-0 ma-0">
            <v-col cols="2">{{ log.updated_at | time }}</v-col>
            <!-- <v-col class="text-capitalize" cols="2">
              {{ log.method }}
            </v-col> -->
            <v-col class="text-capitalize" cols="4" v-html="log.title"> </v-col>
            <v-col cols="6" v-html="log.description"></v-col>
          </v-row>
        </template>
      </v-card>
    </div>
    <div v-show="loading" class="text-center pa-2">
      {{ $t('$vuetify.dataIterator.loadingText') }}
    </div>
    <div v-if="!loading && logs.length == 0">
      <v-card flat>
        <v-card-text class="d-flex justify-center align-center">{{
          $t('$vuetify.noDataText')
        }}</v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logs: { type: Array, default: () => [], required: true },
    loading: Boolean,
  },
  watch: {
    logs: {
      handler(value) {
        this.setData(value)
      },
      immediate: true,
    },
  },
  data: () => ({ itemLog: {} }),
  methods: {
    setData(data) {
      const groups = data.reduce((groups, log) => {
        const date = log.updated_at.split('T')[0]
        if (!groups[date]) {
          groups[date] = []
        }
        groups[date].push(log)
        return groups
      }, {})
      this.itemLog = groups
    },
  },
}
</script>

<style></style>
